module.exports = __webpack_public_path__ + "ad40f3c393ce9598bb969a2126e42a93.png";